
import Vue from "vue";

export default Vue.extend({
	props: {
		labels: {
			type: Array as () => Array<any>,
			required: true
		},
		stepCount: Number,
		currentStep: {
			type: Number,
			default: 0
		},
	},
})
;
